import { Component } from "@angular/core";

@Component({
    selector: "app-background-image",
    template: "",
    styles: [
        `
            :host:before {
                content: "";
                position: fixed;
                display: block;
                top: 0;
                left: 0;
                height: 100vh;
                width: 100vw;
                background-image: none;
                background-position: center;
                background-size: cover;
                background-repeat: no-repeat;
                opacity: 0.2;
            }

            :host[data-state="shipping"]:before {
                background-image: url("../../../assets/bg_1440p.webp");
            }

            :host[data-state="storage"]:before {
                background-image: url("../../../assets/storage-bg.jpg");
            }

            :host[data-state="sustainability"]:before {
                background-image: url("../../../assets/sustainability-bg.jpg");
            }

            :host[data-state="terminal"]:before {
                background-image: url("../../../assets/terminal-bg.jpg");
            }

            :host[data-state="terminal-operations"]:before {
                background-image: url("../../../assets/terminal-tasks-bg.jpg");
            }

            :host[data-state="users"]:before {
                background-image: url("../../../assets/oilrack-bg.jpg");
            }
        `,
    ],
    standalone: false,
})
export class BackgroundImageComponent {}
